import type { IReportCampaign } from '~/modules/campaign-analytics/types';

import { useMetricsTimeFilter } from '~/modules/analytics';
import { ICampaignType } from '~/modules/campaign';
import { EFilterField } from '~/core/gemxql';
import { useMemo } from 'react';

interface IUseGetVersionIdsProps {
  reportCampaign?: IReportCampaign;
}

interface IUseGetVersionIdsReturn {
  versionIds: Record<string, string | undefined> | undefined;
}

export const useGetVersionIds = ({
  reportCampaign,
}: IUseGetVersionIdsProps): IUseGetVersionIdsReturn => {
  const { currentDates } = useMetricsTimeFilter();

  const versionIds = useMemo(() => {
    if (!reportCampaign?.versions || !currentDates.alias) return undefined;

    const matchedVersion = reportCampaign.versions.find((v) => v.version === currentDates.alias);
    if (!matchedVersion) return undefined;

    const isViewCampaignGroup =
      reportCampaign.type === ICampaignType.TEMPLATE_BUNDLE && !reportCampaign.groupId;
    if (isViewCampaignGroup) return { [EFilterField.GROUP_CAMPAIGN_VERSION_ID]: matchedVersion.id };

    return { [EFilterField.CAMPAIGN_VERSION_ID]: matchedVersion.id };
  }, [currentDates.alias, reportCampaign?.groupId, reportCampaign?.type, reportCampaign?.versions]);

  return { versionIds };
};
